export const NewRelic = window.NREUM;

export const noticeError = (err: any, customAttributes = {}) => {
  console.info("noticeError", err, customAttributes);
  NewRelic?.noticeError(err, customAttributes);
};
